import React from 'react';
import styles from './TournamentMatchPlanning.module.css';
import { formatProposalDate } from './formatProposalDate';

const hhmm = (t) => (t ? t.slice(0, 5) : '');

// Kolorystyka i etykiety wzorowane na ligowym getStatusClass/getStatusLabel
// (MatchPlanning.js ok. linii 476-491) — klasy CSS własne modułu turniejowego.
const getStatusClass = (status) => {
    switch (status) {
        case 'ACTIVE': return styles.statusActive;
        case 'ACCEPTED': return styles.statusAccepted;
        case 'EXPIRED': return styles.statusExpired;
        case 'CANCELED': return styles.statusCanceled;
        default: return '';
    }
};

const getStatusLabel = (status) => {
    switch (status) {
        case 'ACTIVE': return 'Aktywna';
        case 'ACCEPTED': return 'Umówiony';
        case 'EXPIRED': return 'Wygasła';
        case 'CANCELED': return 'Anulowana';
        default: return status;
    }
};

const ALREADY_ARRANGED_HINT = 'Macie już umówiony termin — anuluj poprzedni, aby ustalić nowy.';

/**
 * Karta jednej oferty terminu. Świadomie bez własnego stanu i bez wywołań API —
 * całą wiedzę o tym, kto może przyjąć ofertę, dostaje z góry w propsach.
 */
const ProposalCard = ({ proposal, canAccept, canCancel, blockedHint, isMine, alreadyArranged, onAccept, onCancel }) => {
    const isAccepted = proposal.status === 'ACCEPTED';
    const isActive = proposal.status === 'ACTIVE';
    // Rywal, z którym mecz jest już umówiony, nie dostaje wyszarzonego przycisku tylko żaden:
    // backend odrzuciłby taką akceptację (ALREADY_AGREED), ale dopiero po wyborze slotu i kortu.
    const showAcceptButton = !isMine && isActive && !alreadyArranged;

    return (
        <div className={styles.proposalCard}>
            <div className={styles.proposalCardHeader}>
                <span className={styles.proposalCardPlayer}>{proposal.proposerName}</span>
                <span className={`${styles.statusTag} ${getStatusClass(proposal.status)}`}>
                    {getStatusLabel(proposal.status)}
                </span>
                <span className={styles.proposalCardDate}>{formatProposalDate(proposal.proposedDate)}</span>
            </div>

            <div className={styles.proposalCardDetails}>
                {isAccepted ? (
                    <>
                        <span>
                            Umówiony z <strong>{proposal.accepterName}</strong> na{' '}
                            <strong>{hhmm(proposal.slotStartTime || proposal.proposedStartTime)}</strong>
                        </span>
                        {proposal.reservedCourtInfo && (
                            <span className={styles.courtInfo}>{proposal.reservedCourtInfo}</span>
                        )}
                    </>
                ) : (
                    <span>
                        Okno: <strong>{hhmm(proposal.proposedStartTime)}–{hhmm(proposal.proposedEndTime)}</strong>
                    </span>
                )}
            </div>

            <div className={styles.proposalCardActions}>
                {showAcceptButton && (
                    <button
                        type="button"
                        className={styles.acceptButton}
                        disabled={!canAccept}
                        title={!canAccept ? blockedHint : undefined}
                        onClick={() => onAccept(proposal)}
                    >
                        Przyjmij
                    </button>
                )}
                {canCancel && (isActive || isAccepted) && (
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={() => onCancel(proposal)}
                    >
                        Anuluj
                    </button>
                )}
            </div>

            {!isMine && isActive && alreadyArranged && (
                <p className={styles.blockedHint}>{ALREADY_ARRANGED_HINT}</p>
            )}

            {showAcceptButton && !canAccept && blockedHint && (
                <p className={styles.blockedHint}>{blockedHint}</p>
            )}
        </div>
    );
};

export default ProposalCard;
